module.exports = __webpack_public_path__ + "img/1(10).e56f9f77.png";